var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpecialArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "30.7,29.9 47.3,29.9 47.3,12 12,12 12,47.3 30.7,47.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "30.7,226.1 30.7,208.7 12,208.7 12,244 47.3,244 47.3,226.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "225.3,29.9 225.3,47.3 244,47.3 244,12 208.7,12 208.7,29.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "225.3,226.1 208.7,226.1 208.7,244 244,244 244,208.7 225.3,208.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 29.9,
    fill: "#FFFFFF",
    width: 16.6,
    height: 17.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 208.7,
    fill: "#FFFFFF",
    width: 16.6,
    height: 17.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 208.7,
    fill: "#FFFFFF",
    width: 16.6,
    height: 17.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 29.9,
    fill: "#FFFFFF",
    width: 16.6,
    height: 17.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,59.3V0h-59.3v23.9H59.3V0H0v59.3h24.7v137.3H0V256h59.3v-23.9h137.3V256H256v-59.3h-24.7V59.3H256z  M196.7,196.7v23.4H59.3v-23.4H36.7V59.3h22.6V35.9h137.3v23.4h22.6v137.3H196.7z M244,12v35.3h-18.7h-16.6V29.9V12H244z M12,12 h35.3v17.9v17.4H30.7H12V12z M12,244v-35.3h18.7h16.6v17.4V244H12z M244,244h-35.3v-17.9v-17.4h16.6H244V244z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpecialArea);
export default __webpack_public_path__ + "static/media/icon-special-area.3de8294e.svg";
export { ForwardRef as ReactComponent };